import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import green from "@material-ui/core/colors/green";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {CheckBox} from './customUIComponents'
import theme from '../../assests/theme';
import { MuiTypography } from "./MaterialUIComponents";
const styles = {
  // Define custom defualt styles for checkbox label (optional)
  label: {
    color: theme.palette.primary.main
  }
};

function LabeledCheckbox({ label, classes, ...CheckboxProps }) {
  return (
    <FormControlLabel
      label={<MuiTypography variant={theme.typographyStyles.CAPTION} color='primary'>
                {label}
              </MuiTypography>
              }
      classes={classes}
      control={<CheckBox {...CheckboxProps}/>}
      variant={theme.typographyStyles.CAPTION}
    />
  );
}

LabeledCheckbox.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(LabeledCheckbox);
